import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
@Injectable({
  providedIn: 'root',
})
export default class GlobalService {
constructor(
  private tst: ToastrService
) { }
showSuccess(data: string) {
  this.tst.success('', data, {
      timeOut: 2000,
      positionClass: 'toast-top-center',
      progressBar: true,
      progressAnimation: 'increasing',
  });
}
showError(data: string) {
  this.tst.error('', data, {
      timeOut: 2000,
      positionClass: 'toast-bottom-center',
      closeButton: false,
      progressBar: true,
      progressAnimation: 'increasing',
  });
}
showCmplete(data: any) {
  this.tst.warning('', data, {
      timeOut: 2000,
      positionClass: 'toast-bottom-center',
      closeButton: true,
      progressBar: true,
      progressAnimation: 'increasing',
  });
}
  isLAndScape(){
    if(window.orientation !==undefined){
      return Math.abs(window.orientation) ==90
    }
    else if(screen.orientation !==undefined){
      return screen.orientation.type.includes('landscape')
    }
    return false
  }
}
